import { useCallback, useEffect, useState } from 'react';
import Alert from '../../../../shared/components/Alert/Alert';
import Loader from '../../../../shared/components/Loader/Loader';
import { getAffairNodes, updateAffairNodes } from '../affair.api';
import ProjectNodeTreeEditor from './ProjectNodeTreeEditor';

const LOTS = ['CFO', 'CFA', 'SSI', 'PV', 'IRVE', 'CVC', 'Autre'];
const PHASES = ['Chiffrage', 'Conception', 'EXE', 'DOE'];
const countNodes = (nodes = []) => (Array.isArray(nodes) ? nodes : []).reduce((total, node) => total + 1 + countNodes(node.children), 0);

export default function AffairStructurePanel({ affair }) {
  const [nodes, setNodes] = useState([]);
  const [template, setTemplate] = useState('custom');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const [dirty, setDirty] = useState(false);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setNodes(await getAffairNodes(affair.id));
      setDirty(false);
      setError('');
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [affair.id]);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      setSaving(true); setSaved(false); setError('');
      setNodes(await updateAffairNodes(affair.id, nodes));
      setTemplate('custom');
      setDirty(false);
      setSaved(true);
    } catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  if (loading) return <Loader label="Chargement de la structure de l’affaire..." />;
  const nodeCount = countNodes(nodes);

  return <section className="affair-panel affair-structure-panel">
    <header className="affair-structure-panel__header">
      <div>
        <span className="affair-panel__eyebrow">Organisation de l'affaire</span>
        <h2>Structure prévisionnelle</h2>
        <p>Organisez les ouvrages connus dès l'AO. Cette arborescence alimente ensuite le planning, le projet et la LDA.</p>
      </div>
      <div className="affair-structure-panel__save">
        <span className={`affair-save-status${dirty ? ' is-dirty' : ''}`}>{dirty ? 'Modifications non enregistrées' : 'Structure à jour'}</span>
        <button className="basic-button active" type="button" disabled={saving || !dirty} onClick={save}>{saving ? 'Enregistrement...' : 'Enregistrer'}</button>
      </div>
    </header>
    {error && <Alert severity="error">{error}</Alert>}
    {saved && <Alert severity="success">Structure enregistrée.</Alert>}
    <div className="affair-structure-panel__overview">
      <div><span>Ouvrages définis</span><strong>{nodeCount}</strong></div>
      <div><span>Socle commun</span><strong>Général</strong></div>
      <p><b>Flux de données</b><span>Structure</span><i>→</i><span>Planning AO / DCE</span><i>→</i><span>Projet &amp; LDA</span></p>
    </div>
    <ProjectNodeTreeEditor
      projectName={affair.name}
      template={template}
      onTemplateChange={setTemplate}
      nodes={nodes}
      onChange={(next) => { setNodes(next); setSaved(false); setDirty(true); }}
      globalLots={LOTS}
      globalPhases={PHASES}
    />
  </section>;
}
